import { render, staticRenderFns } from "./AssessmentHistory.vue?vue&type=template&id=fbb6f04c&scoped=true"
import script from "./AssessmentHistory.vue?vue&type=script&lang=js"
export * from "./AssessmentHistory.vue?vue&type=script&lang=js"
import style0 from "./AssessmentHistory.vue?vue&type=style&index=0&id=fbb6f04c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbb6f04c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
installComponents(component, {VBadge})
